import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import String from './String';
import { useLanguage } from '../contexts/language';

const SessionExpiredModal = ({ open, onClose }) => {
  const { content } = useLanguage();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="session-expired-dialog-title"
      aria-describedby="session-expired-dialog-description"
    >
      <DialogTitle id="session-expired-dialog-title">
        <String s="session_expired_title" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="session-expired-dialog-description">
          <String s="session_expired_message" />
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ padding: '16px' }}>
        <Button
          onClick={onClose}
          color="primary"
          variant="contained"
          fullWidth
          aria-label={content('session_expired_action')}
        >
          <String s="session_expired_action" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredModal;
